import { motion } from "framer-motion";

const IMG =
  "https://images.unsplash.com/photo-1599008634438-fc6d2be54835?w=1000&q=80&auto=format&fit=crop";

const DorProposito = () => {
  return (
    <section id="sobre" data-testid="dor-proposito-section" className="bg-maternnia-porcelana py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-20 items-center">
          <motion.div
            className="relative order-2 lg:order-1"
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          >
            <div className="rounded-[2rem] overflow-hidden shadow-[0_24px_64px_rgba(43,37,38,0.12)] aspect-[5/4]">
              <img src={IMG} alt="Caderno e café — organização e clareza" loading="lazy" className="w-full h-full object-cover" />
            </div>
            <div className="absolute -bottom-5 -right-5 w-28 h-28 rounded-3xl border border-maternnia-pink/30 hidden md:block" />
          </motion.div>

          <motion.div
            className="order-1 lg:order-2"
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          >
            <span className="text-sm font-semibold tracking-widest text-maternnia-pink uppercase">Nosso propósito</span>
            <h2 className="font-serif text-4xl md:text-5xl tracking-tight text-maternnia-charcoal mt-4 font-medium leading-[1.1]">
              Muita informação. Muitas opiniões.
            </h2>
            <p className="mt-6 text-base md:text-lg text-maternnia-taupe leading-relaxed font-light max-w-xl">
              Entre buscas, recomendações e conselhos que se contradizem, é fácil se sentir sobrecarregada. A Maternnia organiza o que importa em cada fase e aproxima você de profissionais selecionados — para que você encontre clareza e siga o caminho que faz sentido para a sua realidade.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default DorProposito;
